import React from "react";
import BookStore from "../../stores/book-store";

class CustomIframe extends React.Component {
  constructor(props) {
    super(props);
    this.customIframeRef = React.createRef();
    this.showLoading = true;
    if (
      props.custom.lti &&
      props.custom.lti.enabled &&
      Fraction.User.contextTokens &&
      Fraction.User.contextTokens[props.isbn]
    ) {
      Jigsaw.User.createLTILaunch(
        {
          type: props.custom.lti.type,
          isbn: props.isbn,
          brand_key: Fraction.Brand.jigsawBrand
        },
        response => {
          if (response.isSuccess()) {
            this.showLoading = true;
            this.setState({ url: response.data.redirect_url });
          }
        }
      );
      this.state = { url: false };
    } else {
      var url = props.custom.url;
      if (props.custom.parameters) {
        if (props.custom.parameters.vbid) {
          url = Fraction.Helpers.addParameter(url, "vbid", props.isbn);
        }
      }
      this.state = { url: url };
    }
  }

  componentWillUnmount() {
    $(".custom-frame").unbind();

    // Remove event when unloading
    $(window).off("message.customIframe");
  }

  componentDidMount() {
    this.showLoading = true;
    if (this.showLoading) {
      Fraction.Helpers.addLoader($(".custom-iframe"));
      this.showLoading = false;
      $(".custom-frame").bind("load", () => {
        Fraction.Helpers.removeLoader($(".custom-iframe"));
        $(".custom-frame").unbind();
      });
    }

    // Remove event if it was already added (namespaced to this class)
    $(window).off("message.customIframe");

    $(window).on("message.customIframe", e => {
      var data = e.originalEvent.data;

      if (data === "Bookshelf:closeWindow") {
        Fraction.Helpers.removeModal();
      }
    });
  }

  componentDidUpdate() {
    if (this.showLoading) {
      Fraction.Helpers.addLoader($(".custom-iframe"));
      this.showLoading = false;
      $(".custom-frame").unbind("load");
      $(".custom-frame").bind("load", () => {
        Fraction.Helpers.removeLoader($(".custom-iframe"));
      });
    }
  }

  render() {
    //(parseFloat(this.props.height)+parseFloat(this.props.top)!=100) && (divStyle.borderBottomWidth = "7px");
    return (
      <div className="custom-iframe">
        {this.state.url && (
          <iframe
            className="custom-frame"
            src={this.state.url}
            ref={this.customIframeRef}
          />
        )}
      </div>
    );
  }
}

export default CustomIframe;
